import { animeList } from "@/mocks/anime";

const ongoing = animeList.filter((item) => item.status === "连载中").slice(0, 12);

export default function OngoingSeries() {
  return (
    <section id="ongoing" className="bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <div className="max-w-2xl">
          <span className="text-sm font-medium text-primary-600">连载追番</span>
          <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-3xl">正在连载中的作品与追番进度</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
            连载中的作品会在下方展示更新进度条、已播话数与总话数。进度接近尾声时适合一次性补番，前期阶段则更适合边看边追。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-4 md:grid-cols-3 md:gap-5 lg:grid-cols-4">
          {ongoing.map((item) => {
            const percent = Math.round((item.latest / item.total) * 100);
            return (
              <article
                key={item.id}
                className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
              >
                <div className="relative aspect-[3/4] w-full overflow-hidden">
                  <img
                    src={item.cover}
                    alt={`${item.title} 连载封面`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute left-2 top-2 rounded-md bg-secondary-500 px-2 py-0.5 text-[11px] text-background-50">
                    连载中
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-3 md:p-4">
                  <h3 className="truncate text-sm font-medium text-foreground-950 md:text-base">{item.title}</h3>
                  <p className="mt-1 text-xs text-foreground-600">{item.genres.join(" · ")}</p>
                  <div className="mt-3 flex items-center justify-between text-xs text-foreground-700">
                    <span>
                      第 {item.latest} / {item.total} 话
                    </span>
                    <span className="text-accent-700">{percent}%</span>
                  </div>
                  <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                    <div className="h-full rounded-full bg-primary-500" style={{ width: `${percent}%` }}></div>
                  </div>
                  <div className="mt-3 flex items-center justify-between text-xs text-foreground-600">
                    <span className="flex items-center gap-1">
                      <i className="ri-user-heart-line"></i>
                      {item.followers}
                    </span>
                    <span>{item.day}更新</span>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}